<template>
  <div>
    <fade>
      <div
        v-if="componentConfig"
        class="fixed inset-0 bg-gray-200 z-50 bg-opacity-60 cursor-pointer"
        @click="close"
      />
    </fade>
    <slide-right-to-left>
      <div
        v-if="componentConfig"
        class="fixed right-0 top-0 h-full bg-white shadow-md cursor-default flex flex-col overflow-y-scroll z-20"
        style="z-index: 55; transition: width 0.5s ease, transform 0.5s ease;"
        :style="{
          width: expanded ? '100%' : componentConfig.minWidth
        }"
      >
        <div class="flex justify-between px-3 py-5 items-center bg-gradient-to-r from-darkPurple to-darkBlue">
          <div class="flex items-center gap-2">
            <button
              @click="handleExpandClick()"
            >
              <icon
                :name="expanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'"
                color="white"
                :size="25"
              />
            </button>
            <h2 class="text-lg text-white font-bold">
              {{ componentConfig.title || 'Détails' }}
            </h2>
          </div>
          <button
            class="font-bold text-white"
            @click="close"
          >
            Fermer
          </button>
        </div>
        <div
          v-if="componentConfig"
          class="flex-1"
        >
          <component :is="componentConfig.component" v-bind="componentConfig.componentProps" />
        </div>
      </div>
    </slide-right-to-left>
  </div>
</template>

<script lang="ts" setup>
import {ref} from "vue";
import Fade from '@/core/transitions/Fade.vue';
import SlideRightToLeft from '@/core/transitions/SlideRightToLeft.vue';
import Icon from '@/core/components/icon/Icon.vue';

interface Props {
    componentConfig: {
        component?: Element;
        componentProps?: object;
        minWidth: string;
        title?: string;
    } | null;
}

const {
    componentConfig = {
        component: null,
        componentProps: {},
        minWidth: '50%',
        title: ''
    }
} = defineProps<Props>();

const emits = defineEmits(['close']);

const expanded = ref(false);

/**
 * Handle expand click.
 *
 * If the min width is 100%, close completely the drawer.
 */
const handleExpandClick = () => {
    if (componentConfig?.minWidth === "100%") {
        expanded.value = false;
        emits('close');
    } else {
        expanded.value = !expanded.value;
    }
};

/**
 * Close the drawer.
 */
const close = () => {
    expanded.value = false;
    emits('close');
};
</script>
